import React from 'react';
import styles from './Spacer.module.scss';

interface SpacerProps {
	size?: number | string;
	direction?: 'horizontal' | 'vertical';
	className?: string;
}

export const Spacer: React.FC<SpacerProps> = ({ size = 16, direction = 'vertical', className = '' }) => {
	const sizeValue = typeof size === 'number' ? `${size}px` : size;

	const style: React.CSSProperties = direction === 'vertical' ? { height: sizeValue } : { width: sizeValue };

	return <div className={`${styles.spacer} ${className}`} style={style} />;
};
